export const APP_SENDER = 'mobile_app'
